/**
 * Context command: Get user, projects, and permissions
 */

import { createContextService, getApiUrl } from '../utils/client.js';
import { buildProjectLink } from '../../../../src/utils/task-link.js';
import { chalk, formatOutput } from '../utils/format.js';
import { handleApiError } from '../utils/errors.js';

export async function showContext(token?: string, apiUrl?: string, json?: boolean): Promise<void> {
  try {
    const service = await createContextService(token, apiUrl);
    const result = await service.getUserContext();

    if (json) {
      console.log(formatOutput(result, true));
    } else {
      const user = result.user;

      console.log('');
      console.log(chalk.bold.white('  Hypertask Context'));
      console.log(chalk.dim('  ' + '─'.repeat(40)));

      console.log('');
      console.log(chalk.dim('  USER'));
      console.log(`  ${chalk.bold.cyan(user.displayName || user.email)}  ${chalk.dim(`<${user.email}>`)}`);

      if (result.projects && result.projects.length > 0) {
        const appBase = new URL(getApiUrl(apiUrl)).origin;
        console.log('');
        console.log(chalk.dim(`  PROJECTS  ${chalk.dim(`(${result.projects.length})`)}`));
        result.projects.forEach((p: any) => {
          const projectUrl = buildProjectLink(appBase, p.id);
          console.log(`  ${chalk.dim(String(p.id).padStart(5))}  ${chalk.white(p.title)}  ${chalk.dim(projectUrl)}`);
        });
      }

      if (result.all_agents && result.all_agents.length > 0) {
        console.log('');
        console.log(chalk.dim(`  AGENTS  ${chalk.dim(`(${result.all_agents.length})`)}`));
        result.all_agents.forEach((a: any) => {
          const isConnected = result.connected_agent?.id === a.id;
          const marker = isConnected ? chalk.green('●') : chalk.dim('○');
          const name = isConnected ? chalk.bold.green(a.displayName) : chalk.white(a.displayName);
          console.log(`  ${marker}  ${name}  ${chalk.dim(a.id)}`);
        });
      }

      if (result.permissions) {
        console.log('');
        console.log(chalk.dim('  PERMISSIONS'));
        Object.entries(result.permissions).forEach(([key, val]) => {
          const icon = val ? chalk.green('✓') : chalk.red('✗');
          const label = val ? chalk.white(key) : chalk.dim(key);
          console.log(`  ${icon}  ${label}`);
        });
      }

      console.log('');
    }
  } catch (error) {
    handleApiError(error);
  }
}
